import React from "react";

const ThankYouPage = ({ data }) => {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-8">
      <div className="max-w-2xl w-full text-center">
        <div className="bg-white rounded-2xl shadow-xl p-8 animate-slide-up">
          {/* Success Icon */}
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
            <svg
              className="w-8 h-8 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>

          {/* Main Message - Acknowledging the Hero's Call */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Congratulations on Taking the First Step, {data?.firstName}!
          </h1>

          <p className="text-lg text-gray-600 mb-8">
            You've just made a bold decision to transform your business. Your
            personalized roadmap to success is being crafted right now - one
            that will help you overcome the challenges holding your business
            back.
          </p>

          {/* What's Next - The Journey Ahead */}
          <div className="bg-gradient-to-r from-primary-50 to-secondary-50 rounded-xl p-6 mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              Your Path to Success
            </h2>

            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-primary-600 rounded-full flex items-center justify-center text-white text-sm font-semibold flex-shrink-0">
                  1
                </div>
                <div className="text-left">
                  <p className="font-medium text-gray-900">
                    Your Guide Arrives
                  </p>
                  <p className="text-sm text-gray-600">
                    Watch your inbox at <strong>{data?.email}</strong> - your
                    personalized business transformation plan will arrive soon.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-primary-600 rounded-full flex items-center justify-center text-white text-sm font-semibold flex-shrink-0">
                  2
                </div>
                <div className="text-left">
                  <p className="font-medium text-gray-900">
                    Uncover Your Potential
                  </p>
                  <p className="text-sm text-gray-600">
                    Your report reveals the hidden opportunities within your
                    {data?.businessType?.toLowerCase()} business and the exact
                    steps to unlock them.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-primary-600 rounded-full flex items-center justify-center text-white text-sm font-semibold flex-shrink-0">
                  3
                </div>
                <div className="text-left">
                  <p className="font-medium text-gray-900">
                    Chart Your Victory
                  </p>
                  <p className="text-sm text-gray-600">
                    Join us for a 30-minute strategy session where we'll map out
                    your journey from overwhelmed business owner to empowered
                    leader.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Buttons - The Call to Adventure */}
          <div className="space-y-4">
            <button className="w-full bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 btn-focus">
              Secure Your Strategy Session
            </button>

            <p className="text-sm text-gray-500">
              Ready to start now? Call <strong>(555) 123-4567</strong>
            </p>
          </div>

          {/* Additional Info - Support Along the Journey */}
          <div className="mt-8 p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-600">
              <strong>We're Here to Guide You:</strong> Our team of business
              transformation experts is available Monday-Friday, 9 AM - 6 PM
              EST. We'll check in within 24 hours to ensure you're equipped for
              the journey ahead.
            </p>
          </div>
        </div>

        {/* Footer - The Promise of Transformation */}
        <div className="mt-8 text-sm text-gray-500">
          <p>
            Your business transformation story begins now - let's write your
            success chapter together
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
